import firebase from "firebase";
console.log(window.firebaseConfig)
firebase.initializeApp(window.firebaseConfig);